import React from 'react';
import { Admin, Resource } from 'react-admin';
import { UserList } from './resources/Users';
import dataProvider from './dataProvider';
import authProvider from './authProvider';
import CustomLoginPage from './LoginPage';

const AdminApp = () => (
  <Admin
    basename="/frontend-admin-1107"
    dataProvider={dataProvider}
    authProvider={authProvider}
    loginPage={CustomLoginPage}
  >
    <Resource name="users" list={UserList} />
  </Admin>
);

export default AdminApp;